import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import useCasinoRoutes from '~/components/router/use-casino-routes';

const useCasinoLocation = () => {
	const { pathname } = useLocation();
	const { ROUTE_LIVE_CASINO_SEARCH, ROUTE_CASINO_SEARCH } = useCasinoRoutes();

	const isCasinoSearchLocation = useMemo(() => {
		return pathname.includes(ROUTE_CASINO_SEARCH);
	}, [ROUTE_CASINO_SEARCH, pathname]);

	const isLiveCasinoSearchLocation = useMemo(() => {
		return pathname.includes(ROUTE_LIVE_CASINO_SEARCH);
	}, [ROUTE_LIVE_CASINO_SEARCH, pathname]);

	const isSearchLocation = useMemo(() => {
		return pathname.includes(ROUTE_CASINO_SEARCH) || pathname.includes(ROUTE_LIVE_CASINO_SEARCH);
	}, [ROUTE_CASINO_SEARCH, ROUTE_LIVE_CASINO_SEARCH, pathname]);

	return {
		isCasinoSearchLocation,
		isLiveCasinoSearchLocation,
		isSearchLocation
	};
};

export default useCasinoLocation;
